import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import { BodyBuilder } from "../../../exports/Images";
import CardAccordianInfo from "./CardAccordianInfo";

const PTTableCards = ({
  tableData,
  setClickValues,
  tablePagination,
  isPage,
  setIsPage,
  handleDelete,
  onClickBtns,
  isReport,
  userInfoData,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((lead, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <div className="profile-name-number">
                    <div className="profile-image">
                      <img
                        src={
                          lead?.user_profile ? lead.user_profile : BodyBuilder
                        }
                        alt={lead?.user_name || ""}
                        onClick={() => {
                          setClickValues({
                            isModOpen: true,
                            name: "imageModal",
                            viewImage: lead?.user_profile || BodyBuilder,
                            userName: lead?.user_name || "",
                            userNo: lead?.user_mobile || "",
                          });
                        }}
                      />
                    </div>
                    <div className="name-number">
                      <h3 className="lead-name">{lead?.user_name || "NA"}</h3>
                      <p className="number">{lead?.user_mobile || "NA"}</p>
                      {lead?.user_email ? (
                        <span className="value email semi-bold">
                          {lead?.user_email || "NA"}
                        </span>
                      ) : null}
                      {lead?.handover_status === "pending" ? (
                        <span className="handover-pt-status">
                          Handover Pending
                        </span>
                      ) : (
                        <span className="handover-pt-status">
                          {lead?.trial_status === "pending"
                            ? "PT Trial Pending"
                            : lead?.trial_status === "completed"
                            ? "Completed (Not Converted)"
                            : lead?.trial_status === "trial_done_cnvrtd"
                            ? "PT consultation done And Converted"
                            : lead?.trial_status === "trial_notdone_cnvrtd"
                            ? "PT consultation not done And Converted"
                            : lead.trial_status?.replace(/_/g, " ") || "NA"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="card-other-info">
                  <span className="value semi-bold">
                    {lead?.gym_name || "NA"}
                  </span>

                  <>
                    {/* {!lead?.is_pt_prspct &&
                    lead?.handover_status !== "pending" &&
                    lead?.trial_status !== "pending" ? (
                      <span className="not-prospect">Not a PT propsect</span>
                    ) : lead?.is_pt_prspct &&
                      lead?.handover_status !== "pending" &&
                      lead?.trial_status !== "pending" ? (
                      <>
                        {lead?.is_pt_prspct ? (
                          <span className="value label-with-value flex-col">
                            Prospect Amount
                            <b className="semi-bold">
                              ₹{convertThenFormat(lead?.prspct_value || 0)}{" "}
                              {lead?.prspct_status ? (
                                <small className={`${lead?.prspct_status}`}>
                                  {lead?.prspct_status === "closed_not_cnvrtd"
                                    ? "Closed and not converted"
                                    : lead?.prspct_status ===
                                      "closed_cnvrtd_prspct"
                                    ? "Closed and converted"
                                    : lead?.prspct_status ===
                                      "not_specified_prspct"
                                    ? "Prospect Not Specified"
                                    : lead?.prspct_status?.replace(/_/g, " ")}
                                </small>
                              ) : null}
                            </b>
                          </span>
                        ) : null}

                        {lead?.prspct_value ? (
                          <span className="value label-with-value flex-col">
                            Prospect Expected Closure Date
                            <b className="semi-bold">
                              {convertStraight(
                                lead?.expctd_closure_date || "-"
                              )}
                            </b>
                          </span>
                        ) : null}
                      </>
                    ) : null} */}
                  </>
                </div>

                <CardAccordianInfo
                  rowData={lead}
                  setClickValues={setClickValues}
                  onClickBtns={onClickBtns}
                  handleDelete={handleDelete}
                  isReport={isReport}
                  userInfoData={userInfoData}
                />
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default PTTableCards;
